"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BAD_USER_ERRORS;
(function (BAD_USER_ERRORS) {
    BAD_USER_ERRORS["WRONG_USER_TYPE"] = "WRONG_USER_TYPE";
})(BAD_USER_ERRORS = exports.BAD_USER_ERRORS || (exports.BAD_USER_ERRORS = {}));
